module.exports = __webpack_public_path__ + "static/media/happy_bee_mirror.abff573f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bee/happy_bee_mirror.png
// module id = 160
// module chunks = 0